"use client"

import { useState } from "react"
import { Button } from "@/components/ui/button"
import { Facebook, Twitter, Linkedin, Copy, Check } from "lucide-react"

export default function ShareButtons({ drink }) {
  const [copied, setCopied] = useState(false)

  const shareUrl =
    typeof window !== "undefined" ? window.location.href : `https://69cocktails.vercel.app/drinks/${drink.slug}`

  const shareText = `Check out this ${drink.alcoholic ? "cocktail" : "mocktail"}: ${drink.name}`

  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareUrl)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className="space-y-2">
      <h3 className="font-semibold">Share</h3>
      <div className="flex space-x-2">
        <Button
          variant="outline"
          size="icon"
          onClick={() =>
            window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`, "_blank")
          }
          aria-label="Share on Facebook"
        >
          <Facebook className="h-4 w-4" />
        </Button>

        <Button
          variant="outline"
          size="icon"
          onClick={() =>
            window.open(
              `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`,
              "_blank",
            )
          }
          aria-label="Share on Twitter"
        >
          <Twitter className="h-4 w-4" />
        </Button>

        <Button
          variant="outline"
          size="icon"
          onClick={() =>
            window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`, "_blank")
          }
          aria-label="Share on LinkedIn"
        >
          <Linkedin className="h-4 w-4" />
        </Button>

        <Button variant="outline" size="icon" onClick={handleCopyLink} aria-label="Copy link">
          {copied ? <Check className="h-4 w-4 text-green-500" /> : <Copy className="h-4 w-4" />}
        </Button>
      </div>
    </div>
  )
}
